import React, { PropsWithChildren, useLayoutEffect } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { batch, useDispatch } from 'react-redux';
import LoadingContent from '../loadingContent/LoadingContent';
import { updateHub, updateProject, updateSession } from '../../redux/reducers/session';
import { updateHubs, updateProjects } from '../../redux/reducers/entities';
import { useSession } from '../../modules/session';
import { useCustomAuth } from '../../hooks/useCustomAuth';

type Props = PropsWithChildren<unknown>;

export default function SessionSetup({ children }: Props): JSX.Element | null {
  const { isAuthenticated, error, isLoading, user: oauthUser } = useCustomAuth();
  const { user } = useSession();
  const setError = useErrorHandler();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    if (oauthUser?.profile.email === user?.email) {
      return;
    }

    batch(() => {
      dispatch(updateHub(undefined));
      dispatch(updateProject(undefined));
      dispatch(updateHubs(undefined));
      dispatch(updateProjects(undefined));
    });
  }, [dispatch, isAuthenticated, oauthUser?.profile.email, user?.email]);

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    dispatch(updateSession({ authenticatedUser: oauthUser }));
  }, [dispatch, isAuthenticated, oauthUser]);

  if (error) {
    setError(error);

    return null;
  }

  if (isLoading) {
    return <LoadingContent />;
  }

  return <>{children}</>;
}
